// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false


// axios兼容IE
import 'babel-polyfill'
import promise from 'es6-promise';
promise.polyfill();

// axios
import axios from "axios";
axios.defaults.withCredentials = true;
Vue.prototype.$axios=axios;

// ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 响应拦截
axios.interceptors.response.use(
	response => {
		if(response.data.Status == -2){
			sessionStorage.setItem('YunToUrl',location.href);
			console.log('响应拦截response',location.href);
			location.href = response.data.Url;
		}
		return response;
	},
	error => {
        console.log('响应拦截',error)
		return Promise.reject(error)
	}
)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js